/**
 * Ein Signal: „an den Einstellungen hat sich etwas geändert".
 *
 * Relay will nach **jeder** Änderung das Vollbild der Geräteeinstellungen sehen
 * (`server/geraeteEinstellungen.ts`). Geschrieben wird aber an mehreren Stellen — Dialog,
 * Serverzugang, gescannter Code, Fernsetzen. Statt jede davon an den Melder zu hängen (und eine
 * zu vergessen), melden die beiden Schreibwege selbst: `persistence/settings.ts::saveSetting`
 * für die App-Ablage und `platform/einstellungen.ts::schreibeEinstellung` für die iPad-Seite.
 *
 * ⚠️ **Hier steht nur das Signal, nicht der Melder.** `platform/` und `persistence/` sollen
 * den Server nicht kennen; wer zuhören will, meldet sich an (dieselbe Bauform wie
 * `platform/fotos.ts::setBeschriftungsQuelle`).
 */

type Hoerer = () => void;

const hoerer = new Set<Hoerer>();

/** Anmelden; gibt die Abmeldung zurück. */
export function beiEinstellungsAenderung(fn: Hoerer): () => void {
  hoerer.add(fn);
  return () => {
    hoerer.delete(fn);
  };
}

/** Von den Schreibwegen gerufen. Wirft nie — ein Zuhörer darf das Speichern nicht stören. */
export function meldeEinstellungsAenderung(): void {
  for (const fn of hoerer) {
    try {
      fn();
    } catch {
      // Bewusst still: das Speichern ist gelungen, und nur darauf kommt es dem Aufrufer an.
    }
  }
}
